"use strict";

const DataExport = function () {
  var $exportModal;
  var selectedType;

  var init = function () {
    $exportModal = $("#export-modal");
    loadDataExportListeners();
  };

  var loadDataExportListeners = function () {
    $(".data-export-link").off("click", start);
    $(".data-export-link").on("click", start);

    $(".property-export-link").off("click", startProperty);
    $(".property-export-link").on("click", startProperty);

    $exportModal.off("click", ".export-button", handleExportButtonClick);
    $exportModal.on("click", ".export-button", handleExportButtonClick);
  };

  var start = function () {
    $exportModal.html(nunjucks.render("dynamicModals/dataExport.njk"));
    TypeSelection.show($exportModal.find(".modal-body"), setSelectedType);
    $exportModal.modal("show");
  };

  var startProperty = async function () {
    const groupId = Tree.get("activeGroup", "groupId");
    await ApiCalls.exportDataToDownload(`/esg/${groupId}/properties-export`);
  };

  var setSelectedType = function (type) {
    if (type.value === undefined) {
      throw Error("Type must have a value property.");
    }
    if (type.name === undefined) {
      throw Error("Type must have a name property.");
    }
    selectedType = type;
  };

  var handleExportButtonClick = function () {
    exportData(selectedType);
  };

  var exportData = function (selectedType) {
    const url = getExportURL(selectedType.handler, selectedType.value);
    const requestData = {
      service: Tree.get("dataView"),
      dataType: selectedType.value,
    };

    closeModal();
    showStartingMessage(selectedType.emailFile);
    getExportData(url, requestData, selectedType.emailFile);
  };

  var getExportData = async function (url, requestData, emailFile) {
    try {
      if (emailFile) {
        await ApiCalls.exportDataToEmail(url, requestData);
      } else {
        await ApiCalls.exportDataToDownload(url, requestData);
      }
    } catch {
      $exportModal.modal("hide");
      MessageModal.showSimpleWarningModal(
        "The export has failed! Please try again later or <a href='https://kb.2ndnaturewater.com/knowledge/kb-tickets/new' target='_blank'>contact support</a> for assistance.",
        true,
      );
    }
  };

  var getExportURL = function (exportType, dataType) {
    const groupId = Tree.get("activeGroup", "groupId");
    const data = Tree.get("dataView");
    var url = {
      postgis: `/shapes/${groupId}/${data}`,
      excel: `/exports/${groupId}/${data}`,
      geoserver: `/geoserver/${groupId}/export`,
      "telr-excel": `/exports/swtelr/${groupId}`,
      "telr-shapefile": `/shapes/swtelr/${groupId}`,
    };
    Analytics.sendAction(["export_data", `${dataType}_${exportType}`], { truncate: true });

    return url[exportType];
  };

  var closeModal = function () {
    var modalBody = $exportModal.find(".modal-body");
    var modalFooter = $exportModal.find(".modal-footer");

    TypeSelection.cleanUp();
    modalBody.empty();
    modalFooter.empty();
    $exportModal.modal("hide");
  };

  var showStartingMessage = function (emailFile) {
    let message;

    if (emailFile) {
      message =
        "Your export is being prepared and will be emailed to you when ready. This may take a while for larger exports.";
    } else {
      message = "Your download will begin shortly.";
    }

    MessageModal.showSimpleWarningModal(message);
  };

  var handleReportDisabledLink = function () {
    var disabled = Progeny.activeHasProgeny() || !ReportDataViewFunctions.isTelrDataView();

    $(".import-export").find(".data-export-link").toggleClass("disabled", disabled);
  };

  return {
    init,
    start,
    exportData,
    handleReportDisabledLink,
  };
};

module.exports = DataExport();

const TypeSelection = require("./typeSelection");
const Analytics = require("../general/analytics");
const Tree = require("../tree");
const ApiCalls = require("../apiCalls");
const MessageModal = require("../modals/messageModal");
const ReportDataViewFunctions = require("../report/dataViewFunctions");
const Progeny = require("../login/progeny");
